import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=a3736b5e"
import script from "./Consumables.vue?vue&type=script&lang=js"
export * from "./Consumables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports